/* =================================================================
   Traditional Zürich — Grooming Advisor v2 (self-contained)
   - Self-injects modal HTML + styles (no tzh.js dependency)
   - Defensive: re-binds on every open, handles double-open
   - Live-shop SKUs + Shopify CDN images
   - Recommendation engine with deterministic test cases
   - CTAs: product, bundle, camera-check, WhatsApp, PDF
   - Webhook-ready payload (window.TZH_CONFIG.advisorWebhook)
   ================================================================= */
(function(){
'use strict';
if (window.__TZH_ADVISOR_LOADED__) return;
window.__TZH_ADVISOR_LOADED__ = true;

// --- Resolve root path (works in subfolders) -----------------------
function rootPath(){
  if (document.body && document.body.getAttribute('data-root') != null) return document.body.getAttribute('data-root');
  // Heuristic: if pathname has /products/, /bart-probleme/, /bundles/, /freebie/, /lp/, /pages/ → "../"
  const p = location.pathname;
  if (/\/(products|bart-probleme|bundles|freebie|lp|pages)\//.test(p)) return '../';
  return '';
}

// --- Question Set (Barber Concierge — 6 Kernfragen + 2 optional) --
const QUESTIONS = [
  { tag:'length', q:'Wie lang trägst du deinen Bart?',
    hint:'Wähle, was am ehesten passt — kein Millimeter-Maßband nötig.',
    opts:['Stoppel','Kurz (3–10 mm)','Mittel (10–25 mm)','Lang (>25 mm)'] },
  { tag:'skin_type', q:'Wie fühlt sich die Haut unter deinem Bart an?',
    hint:'Antworte nach Gefühl.',
    opts:['Trocken','Normal','Empfindlich','Eher fettig'] },
  { tag:'problem', q:'Was beschäftigt dich am meisten?',
    hint:'Wähle das Hauptthema.',
    opts:['Hautschüppchen','Juckreiz','Eingewachsene Haare','Trockene Haut','Nichts Spezifisches'] },
  { tag:'finish', q:'Welches Styling-Finish möchtest du?',
    opts:['Gepflegt natürlich','Matt','Weich gepflegt','Leicht glänzend'] },
  { tag:'care_goal', q:'Was ist dir bei deiner Bartpflege am wichtigsten?',
    hint:'Wähle das wichtigste Ziel — wir setzen die Routine darauf.',
    opts:['Weniger Juckreiz und Schuppen','Mehr Weichheit und Pflege','Saubere Konturen und gepflegter Look','Einfache Routine mit wenigen Produkten'] },
  { tag:'routine_level', q:'Welches Routine-Level passt zu dir?',
    hint:'Wir wählen 2–4 Produkte entsprechend.',
    opts:['Schnell (2 Produkte)','Komplett (3 Produkte)','Premium (4 Produkte)'] }
];

// --- Live-Shop Product Library (from traditional-zuerich.ch) ------
const PRODUCTS = {
  SCRUB:     { handle:'beard-scrub',       title:'Beard Scrub',           blurb:'Bart-Peeling. 2× pro Woche.',                                  price:65.00, sku:'beard-scrub',       img:'https://traditional-zuerich.ch/cdn/shop/files/bartpflege-beard-scrub-traditional-zuerich-peeling-100-g-vs.png?v=1701277428&width=300' },
  TREATMENT: { handle:'beard-treatment',   title:'Beard Treatment',       blurb:'Bartcrème mit Aloe Vera + Sheabutter. Täglich.',               price:39.50, sku:'beard-treatment',   img:'https://traditional-zuerich.ch/cdn/shop/files/bartpflege-beard-treatment-traditional-zuerich-bartcreme-50-g-vs-a.png?v=1702286916&width=300' },
  OIL:       { handle:'shave-beard-oil',   title:'Shave & Beard Oil',     blurb:'Bartöl mit Rizinus, Jojoba, Aprikose, Sonnenblume.',           price:55.00, sku:'shave-beard-oil',   img:'https://traditional-zuerich.ch/cdn/shop/files/bartpflege-shave-and-beard-oil-traditional-zuerich-bartoel-50-ml-vs.png?v=1701277495&width=300' },
  CREAM:     { handle:'forming-cream',     title:'Forming Cream',         blurb:'Haarwachs / Forming Cream für matt-natürliches Finish.',       price:29.50, sku:'forming-cream',     img:'https://traditional-zuerich.ch/cdn/shop/files/hairstyling-forming-cream-traditional-zuerich-haarwachs-50-g-vs-a.png?v=1702287374&width=300' },
  BRUSH_S:   { handle:'bartbuersten',      title:'Bartbürste klein',      blurb:'Naturhaar, Holzgriff. Für tägliches Tragen.',                  price:29.00, sku:'bartbuerste-klein', img:null },
  BRUSH_L:   { handle:'bartbuersten',      title:'Bartbürste gross',      blurb:'Naturhaar, Holzgriff. Mittlere Grösse — für die meisten Bärte.',                     price:39.00, sku:'bartbuerste-gross', img:null },
  BUNDLE_STARTER: { handle:'bundles/starter-routine', title:'Starter Routine', blurb:'Beard Scrub + Treatment + Bürste. 15 % sparen.',          price:119.00, sku:'bundle-starter', img:null, saving_pct:15 },
  BUNDLE_BIG:     { handle:'big-beard-box',           title:'Beard Box',       blurb:'Scrub, Treatment und Oil im 3-teiligen Set.',              price:149.00, sku:'big-beard-box',  img:null, saving_pct:9 }
};

// --- Recommendation Engine (Concierge — 6 questions) --------------
function recommend(answers){
  const score = { SCRUB:0, TREATMENT:0, OIL:0, CREAM:0, BRUSH_S:0, BRUSH_L:0 };
  const a = answers || {};
  const isMidLong = ['Mittel (10–25 mm)','Lang (>25 mm)'].includes(a.length);
  const isShort   = ['Stoppel','Kurz (3–10 mm)'].includes(a.length);
  const problem = a.problem || '';

  // SCRUB (skin renewal)
  if(problem==='Hautschüppchen')        score.SCRUB += 7;
  if(problem==='Eingewachsene Haare')   score.SCRUB += 6;
  if(a.skin_type==='Empfindlich')       score.SCRUB -= 1;
  if(isMidLong)                          score.SCRUB += 1;

  // TREATMENT (daily care)
  if(a.skin_type==='Trocken')           score.TREATMENT += 6;
  if(a.skin_type==='Empfindlich')       score.TREATMENT += 5;
  if(a.skin_type==='Normal')            score.TREATMENT += 4;
  if(problem==='Trockene Haut')         score.TREATMENT += 6;
  if(problem==='Juckreiz')              score.TREATMENT += 4;

  // OIL (shine / softness)
  if(isMidLong) score.OIL += 4;
  if(a.skin_type==='Trocken') score.OIL += 2;
  if(a.finish==='Leicht glänzend') score.OIL += 4;
  if(a.finish==='Weich gepflegt') score.OIL += 3;
  if(a.skin_type==='Eher fettig') score.OIL -= 2;

  // CREAM (Forming)
  if(isMidLong) score.CREAM += 4;
  if(a.finish==='Matt') score.CREAM += 6;
  if(a.skin_type==='Eher fettig') score.CREAM += 2;
  if(a.length==='Stoppel') score.CREAM -= 3;

  // BÜRSTE (tool)
  if(isMidLong) score.BRUSH_L += 6;
  if(isShort)   score.BRUSH_S += 5;

  // Routine-Level controls target count
  const level = a.routine_level || 'Komplett (3 Produkte)';
  const targetCount = level.indexOf('Schnell') === 0 ? 2 : (level.indexOf('Premium') === 0 ? 4 : 3);

  // Sort by score descending, take top N >= 4 threshold
  let sorted = Object.entries(score).sort((a,b)=>b[1]-a[1]);
  let routine = sorted.filter(([_,v])=>v>=4).slice(0,targetCount).map(([k])=>k);

  // Always ensure at least TREATMENT in routine if nothing else picks
  if(routine.length===0){ routine = ['TREATMENT', isShort?'BRUSH_S':'BRUSH_L']; }

  // Pad to target if needed
  const restPool = ['TREATMENT','SCRUB','OIL', isShort?'BRUSH_S':'BRUSH_L','CREAM'];
  for(let i=0; i<restPool.length && routine.length<targetCount; i++){
    if(!routine.includes(restPool[i])) routine.push(restPool[i]);
  }

  // Cap to targetCount
  routine = routine.slice(0, targetCount);

  let bundle = null;
  if(targetCount===4) bundle='BIG';
  else if(targetCount===3 && routine.includes('SCRUB') && routine.includes('TREATMENT')) bundle='STARTER';

  return { score, routine, bundle, targetCount, level, care_goal: a.care_goal };
}

// --- Narrative ----------------------------------------------------
function buildIntro(a){
  if(a.problem==='Hautschüppchen') return 'Für Hautschüppchen unter dem Bart empfehlen wir Reinigung vor Pflege.';
  if(a.problem==='Eingewachsene Haare') return 'Eingewachsene Haare — wir starten mit dem Beard Scrub.';
  if(a.problem==='Trockene Haut') return 'Trockene Haut unter dem Bart — Pflege und Feuchtigkeit im Vordergrund.';
  if(a.problem==='Juckreiz') return 'Juckreiz — sanfte Pflege beruhigt die Haut.';
  if(a.length==='Lang (>25 mm)' && a.finish==='Matt') return 'Langer Bart, mattes Finish — Pflege plus Form.';
  if(a.skin_type==='Empfindlich') return 'Empfindliche Haut — sanfte Pflege im Vordergrund.';
  if(a.skin_type==='Eher fettig') return 'Eher fettige Haut — leichte Pflege, mattes Finish.';
  return 'Auf Basis deiner Antworten empfehlen wir diese Routine.';
}
function buildBundleHint(bundle, level){
  if(bundle==='BIG')     return { strong:'Beard Box · 3 Produkte', text:'Scrub, Treatment und Oil im Set — CHF 14.50 Preisvorteil gegenüber Einzelkauf.' };
  if(bundle==='STARTER') return { strong:'Starter Routine · 3 Produkte', text:'Drei Kern-Produkte als Set — Einstiegs-Bundle mit Preisvorteil.' };
  return null;
}

// --- State --------------------------------------------------------
const state = { step:0, answers:{}, sessionId:'ses_'+Date.now()+'_'+Math.random().toString(36).slice(2,8), opened:false };

// --- Self-injected styles (scoped) --------------------------------
const STYLES = `
.tzh-adv-overlay{position:fixed;inset:0;background:rgba(11,13,18,.72);z-index:9998;display:none;align-items:flex-end;justify-content:center;padding:0;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}
.tzh-adv-overlay.is-open{display:flex}
.tzh-adv-panel{background:#FFFFFF;color:#1E2430;width:100%;max-width:620px;max-height:92vh;border-radius:0;display:flex;flex-direction:column;overflow:hidden;font-family:Inter,system-ui,sans-serif;box-shadow:0 -24px 60px rgba(0,0,0,.3)}
.tzh-adv-head{padding:18px 24px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #E4E7EC;background:#FFFFFF}
.tzh-adv-meta{font-family:"Inter",system-ui,sans-serif;font-size:11px;color:#6B7280;text-transform:uppercase;letter-spacing:.22em;font-weight:600}
.tzh-adv-close{background:none;border:0;width:34px;height:34px;border-radius:50%;cursor:pointer;font-size:22px;color:#2B2622;display:grid;place-items:center;transition:background .15s ease}
.tzh-adv-close:hover{background:rgba(26,22,20,.08)}
.tzh-adv-progress{height:2px;background:#E4E7EC;position:relative}
.tzh-adv-progress span{display:block;height:100%;background:#C8A24E;width:0%;transition:width .3s ease}
.tzh-adv-body{padding:40px 24px;overflow-y:auto;flex:1;-webkit-overflow-scrolling:touch;background:#FFFFFF}
.tzh-adv-eyebrow{display:inline-block;font-family:"Inter",system-ui,sans-serif;font-size:11px;letter-spacing:.24em;text-transform:uppercase;color:#1B2A55;font-weight:600;margin-bottom:14px;padding-bottom:6px;border-bottom:1px solid #C8A24E}
.tzh-adv-q{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:28px;line-height:1.15;margin:0 0 10px;color:#0B0D12;max-width:24ch;letter-spacing:-.005em}
.tzh-adv-hint{font-size:14px;color:#6B7280;margin:0 0 22px;line-height:1.55}
.tzh-adv-opts{display:grid;grid-template-columns:1fr;gap:10px}
.tzh-adv-opt{display:flex;justify-content:space-between;align-items:center;width:100%;padding:16px 18px;background:#FFFFFF;border:1px solid #E4E7EC;border-radius:0;font-family:Inter,system-ui,sans-serif;font-size:15px;font-weight:500;color:#0B0D12;cursor:pointer;text-align:left;transition:transform .15s ease,border-color .15s ease,background .15s ease;-webkit-tap-highlight-color:transparent}
.tzh-adv-opt:hover{border-color:#1B2A55;transform:translateY(-1px)}
.tzh-adv-opt.is-selected{background:#0B0D12;color:#FFFFFF;border-color:#0B0D12}
.tzh-adv-opt.is-selected::after{content:"✓";color:#C8A24E;font-weight:700;margin-left:12px;font-size:14px}
.tzh-adv-foot{padding:16px 24px;border-top:1px solid #E4E7EC;background:#FFFFFF;display:flex;justify-content:space-between;gap:12px}
.tzh-adv-btn{display:inline-flex;align-items:center;justify-content:center;min-width:140px;height:52px;padding:0 28px;border-radius:0;font-family:Inter,system-ui,sans-serif;font-weight:600;font-size:13px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;transition:transform .15s ease,opacity .15s ease,background .15s ease,color .15s ease;border:1px solid transparent;text-decoration:none;line-height:1}
.tzh-adv-btn-primary{background:#0B0D12;color:#FFFFFF;border-color:#0B0D12}
.tzh-adv-btn-primary:hover{background:#1B2A55;border-color:#1B2A55}
.tzh-adv-btn-secondary{background:transparent;color:#0B0D12;border-color:#0B0D12}
.tzh-adv-btn-secondary:hover{background:#0B0D12;color:#FFFFFF}
.tzh-adv-btn-brass{background:#1B2A55;color:#FFFFFF;border-color:#1B2A55}
.tzh-adv-btn-brass:hover{background:#0B0D12;border-color:#0B0D12}
.tzh-adv-btn:disabled{opacity:.38;cursor:not-allowed}
.tzh-adv-btn-full{width:100%}
.tzh-adv-link{background:transparent;border:0;color:#0B0D12;font-family:Inter,system-ui,sans-serif;font-size:11px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;text-decoration:none;cursor:pointer;padding:14px;text-align:center;border-bottom:1px solid #C8A24E;display:inline-block;align-self:center}
.tzh-adv-link:hover{color:#1B2A55;border-bottom-color:#1B2A55}
.tzh-adv-result{padding:40px 24px;overflow-y:auto;flex:1;-webkit-overflow-scrolling:touch;background:#FFFFFF}
.tzh-adv-result h3{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:26px;line-height:1.15;margin:0 0 12px;color:#0B0D12;max-width:24ch;letter-spacing:-.005em}
.tzh-adv-result-lead{font-size:14px;color:#4A5266;line-height:1.55;margin:0 0 24px;max-width:48ch}
.tzh-adv-routine{display:grid;gap:8px;margin-bottom:22px}
.tzh-adv-item{display:flex;gap:14px;align-items:center;padding:14px;background:#FFFFFF;border:1px solid #E4E7EC;border-radius:0}
.tzh-adv-item-num{width:32px;height:32px;border:1px solid #0B0D12;border-radius:50%;display:grid;place-items:center;font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;flex-shrink:0;font-size:14px;color:#0B0D12}
.tzh-adv-item-thumb{width:54px;height:54px;flex-shrink:0;background:#F6F7F9;border-radius:0;display:grid;place-items:center;padding:6px;border:1px solid #E4E7EC}
.tzh-adv-item-thumb img{max-width:100%;max-height:100%;object-fit:contain;display:block}
.tzh-adv-item-thumb.is-set{background:linear-gradient(140deg,#9C7B45,#B8915A,#E8DFD3);font-family:"Cormorant Garamond",Georgia,serif;color:#1A1614;font-style:italic;font-size:9px;font-weight:700;text-align:center;line-height:1.05}
.tzh-adv-item-body{flex:1;min-width:0}
.tzh-adv-item-body h4{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:17px;line-height:1.15;margin:0 0 3px;color:#0B0D12}
.tzh-adv-item-body p{font-size:13px;color:#4A5266;line-height:1.45;margin:0}
.tzh-adv-item-body strong{font-weight:600;color:#0B0D12}
.tzh-adv-bundle{margin-bottom:22px;padding:16px;background:#F6F7F9;border:1px solid #1B2A55;border-radius:0;font-size:13px;color:#4A5266;line-height:1.55}
.tzh-adv-bundle strong{display:block;margin-bottom:4px;color:#0B0D12;font-weight:700;font-family:"Cormorant Garamond",Georgia,serif;font-size:16px;font-style:italic}
.tzh-adv-actions{display:grid;gap:8px}
.tzh-adv-actions-row{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.tzh-adv-actions-row .tzh-adv-btn{min-width:0}
.tzh-adv-disclaimer{font-size:11px;color:#736B5F;margin-top:18px;text-align:center;line-height:1.5}
.tzh-adv-emailform{display:none;padding:14px;background:#EEE7D6;border-radius:4px;margin-top:16px}
.tzh-adv-emailform.is-open{display:block}
.tzh-adv-emailform label{display:block;font-family:"Inter",system-ui,sans-serif;font-size:11px;letter-spacing:.2em;text-transform:uppercase;font-weight:600;color:#6B7280;margin-bottom:6px}
.tzh-adv-emailform input[type="email"]{display:block;width:100%;height:46px;padding:0 14px;background:#fff;color:#1A1614;border:1.5px solid #D5C8B0;border-radius:2px;font-size:14px;font-family:inherit}
.tzh-adv-emailform input[type="email"]:focus{outline:none;border-color:#1A1614}
.tzh-adv-emailform .tzh-adv-check{display:flex;gap:8px;align-items:flex-start;font-size:12px;color:#736B5F;line-height:1.45;margin-top:10px;cursor:pointer}
.tzh-adv-emailform .tzh-adv-check input{margin-top:2px;width:14px;height:14px;accent-color:#1A1614}
@media (min-width:768px){
  .tzh-adv-overlay{align-items:center;padding:20px}
  .tzh-adv-panel{border-radius:10px;max-height:88vh}
  .tzh-adv-q{font-size:34px}
}
@media (prefers-reduced-motion:reduce){
  .tzh-adv-progress span{transition:none}
  .tzh-adv-opt{transition:none}
  .tzh-adv-btn{transition:none}
}
`;

// --- Mount: inject styles + HTML once ----------------------------
function mount(){
  if(document.getElementById('tzhAdvisorOverlay')) return;
  if(!document.head) return;

  // Inject styles
  if(!document.getElementById('tzhAdvisorStyles')){
    const st = document.createElement('style');
    st.id = 'tzhAdvisorStyles';
    st.textContent = STYLES;
    document.head.appendChild(st);
  }

  // Inject overlay
  const overlay = document.createElement('div');
  overlay.id = 'tzhAdvisorOverlay';
  overlay.className = 'tzh-adv-overlay';
  overlay.setAttribute('role','dialog');
  overlay.setAttribute('aria-modal','true');
  overlay.setAttribute('aria-labelledby','tzhAdvQ');
  const LOGO = 'https://traditional-zuerich.ch/cdn/shop/files/Traditional-Zurich-Logo_f426438e-4fe5-43b9-8bd1-1b77666b7eb3.svg?v=1701978513';
  overlay.innerHTML = `
    <div class="tzh-adv-panel">
      <div class="tzh-adv-head">
        <div style="display:flex;align-items:center;gap:10px">
          <img src="${LOGO}" alt="Traditional Zürich" style="height:28px;width:auto">
          <span class="tzh-adv-meta" id="tzhAdvMeta">Frage 1 von 7</span>
        </div>
        <button class="tzh-adv-close" type="button" data-tzh-action="close" aria-label="Beratung schließen">×</button>
      </div>
      <div class="tzh-adv-progress"><span id="tzhAdvProgress"></span></div>
      <div class="tzh-adv-body" id="tzhAdvBody"></div>
      <div class="tzh-adv-result" id="tzhAdvResult" style="display:none"></div>
      <div class="tzh-adv-foot" id="tzhAdvFoot">
        <button class="tzh-adv-btn tzh-adv-btn-secondary" type="button" data-tzh-action="prev" disabled>Zurück</button>
        <button class="tzh-adv-btn tzh-adv-btn-primary" type="button" data-tzh-action="next" disabled>Weiter</button>
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  // Click delegation INSIDE the overlay (no dependency on tzh.js)
  overlay.addEventListener('click', (e) => {
    const tgt = e.target.closest('[data-tzh-action]');
    if(!tgt) return;
    const action = tgt.getAttribute('data-tzh-action');
    if(action==='close')   close();
    else if(action==='prev') prev();
    else if(action==='next') next();
    else if(action==='select-opt') selectOpt(tgt.getAttribute('data-opt'));
    else if(action==='add-routine') addRoutineToCart(tgt);
    else if(action==='toggle-email') document.getElementById('tzhAdvEmailForm').classList.toggle('is-open');
    else if(action==='submit-email') submitEmail();
    else if(action==='go-camera-check') { window.location.href = '/pages/bart-check'; }
    else if(action==='go-whatsapp') {
      const phone = (window.TZH_CONFIG && window.TZH_CONFIG.whatsappNumber) || '41438176870';
      const msg = encodeURIComponent('Hallo, ich habe gerade den Grooming Advisor gemacht. Ich hätte eine Frage zu meiner Routine.');
      window.open('https://wa.me/'+phone+'?text='+msg,'_blank','noopener,noreferrer');
      track('whatsapp_click', { source:'advisor' });
    }
    else if(action==='go-pdf') { window.location.href = '/pages/bartpflege'; }
  });

  // Close on overlay background click (only direct overlay, not panel)
  overlay.addEventListener('click', (e) => { if(e.target === overlay) close(); });

  // ESC closes
  document.addEventListener('keydown', (e) => { if(e.key==='Escape' && overlay.classList.contains('is-open')) close(); });
}

// --- Public open/close --------------------------------------------
function open(){
  mount();
  const overlay = document.getElementById('tzhAdvisorOverlay');
  if(!overlay) return console.warn('[Advisor] Mount failed');
  state.step = 0;
  state.answers = {};
  state.opened = true;
  overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  document.getElementById('tzhAdvBody').style.display = 'block';
  document.getElementById('tzhAdvFoot').style.display = 'flex';
  document.getElementById('tzhAdvResult').style.display = 'none';
  renderQ();
  track('advisor_start', { session_id: state.sessionId });
}
function close(){
  const overlay = document.getElementById('tzhAdvisorOverlay');
  if(overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
  state.opened = false;
}

// --- Render question ----------------------------------------------
function renderQ(){
  const q = QUESTIONS[state.step];
  const total = QUESTIONS.length;
  const meta = document.getElementById('tzhAdvMeta');
  const bar  = document.getElementById('tzhAdvProgress');
  const body = document.getElementById('tzhAdvBody');
  if(!meta||!bar||!body) return;

  meta.textContent = 'Frage '+(state.step+1)+' von '+total;
  bar.style.width = (state.step/total*100)+'%';

  const current = state.answers[q.tag] || (q.multi?[]:null);

  const optsHTML = q.opts.map(opt => {
    const selected = q.multi ? current.includes(opt) : current===opt;
    return '<button class="tzh-adv-opt'+(selected?' is-selected':'')+'" type="button" data-tzh-action="select-opt" data-opt="'+esc(opt)+'">'+esc(opt)+'</button>';
  }).join('');

  body.innerHTML =
    '<span class="tzh-adv-eyebrow">'+(q.multi?'Mehrfachauswahl':'Eine Antwort')+'</span>'+
    '<h3 class="tzh-adv-q" id="tzhAdvQ">'+esc(q.q)+'</h3>'+
    (q.hint?'<p class="tzh-adv-hint">'+esc(q.hint)+'</p>':'')+
    '<div class="tzh-adv-opts" role="listbox" aria-label="'+esc(q.q)+'">'+optsHTML+'</div>';

  // Foot state
  const foot = document.getElementById('tzhAdvFoot');
  const prevBtn = foot.querySelector('[data-tzh-action="prev"]');
  const nextBtn = foot.querySelector('[data-tzh-action="next"]');
  prevBtn.disabled = state.step===0;
  const has = q.multi ? (state.answers[q.tag]||[]).length>0 : !!state.answers[q.tag];
  nextBtn.disabled = !has;
  nextBtn.textContent = state.step === total-1 ? 'Empfehlung anzeigen' : 'Weiter';
}
function selectOpt(opt){
  const q = QUESTIONS[state.step];
  if(q.multi){
    let arr = state.answers[q.tag] || [];
    const idx = arr.indexOf(opt);
    if(idx>=0) arr.splice(idx,1); else arr.push(opt);
    state.answers[q.tag] = arr;
  } else {
    state.answers[q.tag] = opt;
  }
  renderQ();
}
function next(){
  if(state.step < QUESTIONS.length-1){
    state.step++; renderQ();
    track('advisor_q_answered', { step: state.step, session_id: state.sessionId });
  } else {
    showResult();
  }
}
function prev(){ if(state.step>0){ state.step--; renderQ(); } }

// --- Result -------------------------------------------------------
function showResult(){
  const { routine, bundle, level } = recommend(state.answers);
  const bar = document.getElementById('tzhAdvProgress');
  const body = document.getElementById('tzhAdvBody');
  const foot = document.getElementById('tzhAdvFoot');
  const res = document.getElementById('tzhAdvResult');
  if(bar) bar.style.width = '100%';
  if(body) body.style.display = 'none';
  if(foot) foot.style.display = 'none';
  if(!res) return;
  res.style.display = 'block';

  const intro = buildIntro(state.answers);
  const bundleHint = buildBundleHint(bundle, level);
  const wantsCameraCheck = state.answers.problem === 'Hautschüppchen' || state.answers.problem === 'Eingewachsene Haare';

  // Sum total price
  const totalEinzel = routine.reduce((s,c) => s + (PRODUCTS[c].price || 0), 0);
  const bundlePrice = bundle ? PRODUCTS['BUNDLE_'+bundle].price : null;

  const itemsHTML = routine.map((code,i) => {
    const p = PRODUCTS[code];
    const thumb = p.img ? '<div class="tzh-adv-item-thumb"><img src="'+p.img+'" alt=""></div>' : '<div class="tzh-adv-item-thumb is-set">'+esc(p.title.split(' ').slice(0,2).join('<br>'))+'</div>';
    return '<div class="tzh-adv-item">'+
      '<div class="tzh-adv-item-num">'+(i+1)+'</div>'+
      thumb+
      '<div class="tzh-adv-item-body"><h4>'+esc(p.title)+'</h4><p>'+esc(p.blurb)+' <strong>CHF '+p.price.toFixed(2)+'</strong></p></div>'+
      '</div>';
  }).join('');

  const bundleBlock = bundleHint
    ? '<div class="tzh-adv-bundle"><strong>'+esc(bundleHint.strong)+'</strong>'+esc(bundleHint.text)+(bundlePrice?' <em style="display:block;margin-top:6px;color:#1B2A55;font-style:normal;font-weight:700">Bundle CHF '+bundlePrice.toFixed(2)+'</em>':'')+'</div>'
    : '';

  const totalBlock = '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:14px 0;border-top:1px solid #E5EAF2;margin-bottom:18px"><span style="font-family:Inter,system-ui,sans-serif;font-size:11px;letter-spacing:.22em;text-transform:uppercase;color:#6B7280;font-weight:600">Routine-Summe (Einzelkauf)</span><strong style="font-size:18px;color:#0B0D12">CHF '+totalEinzel.toFixed(2)+'</strong></div>';

  res.innerHTML =
    '<span class="tzh-adv-eyebrow">Deine Routine</span>'+
    '<h3>'+esc(intro)+'</h3>'+
    '<p class="tzh-adv-result-lead">'+routine.length+' Produkt(e) · '+esc(level||'')+'</p>'+
    '<div class="tzh-adv-routine">'+itemsHTML+'</div>'+
    totalBlock+
    bundleBlock+
    '<div class="tzh-adv-actions">'+
      '<button class="tzh-adv-btn tzh-adv-btn-primary tzh-adv-btn-full" type="button" data-tzh-action="add-routine" data-handles="'+routine.map(c=>PRODUCTS[c].sku).join(',')+'" data-bundle="'+(bundle||'')+'">Routine in den Warenkorb</button>'+
      '<div class="tzh-adv-actions-row">'+
        (wantsCameraCheck ? '<button class="tzh-adv-btn tzh-adv-btn-brass" type="button" data-tzh-action="go-camera-check">Termin im Barbershop</button>' : '<button class="tzh-adv-btn tzh-adv-btn-secondary" type="button" data-tzh-action="toggle-email">Beratung speichern</button>')+
        '<button class="tzh-adv-btn tzh-adv-btn-secondary" type="button" data-tzh-action="go-whatsapp">Frage per WhatsApp</button>'+
      '</div>'+
      (wantsCameraCheck ? '<button class="tzh-adv-link" type="button" data-tzh-action="toggle-email">Beratung per E-Mail speichern</button>' : '<button class="tzh-adv-link" type="button" data-tzh-action="go-pdf">Gratis Pflege-Guide herunterladen</button>')+
    '</div>'+
    '<div class="tzh-adv-emailform" id="tzhAdvEmailForm">'+
      '<label for="tzhAdvEmail">E-Mail-Adresse</label>'+
      '<input type="email" id="tzhAdvEmail" placeholder="deine@email.ch" required autocomplete="email">'+
      '<label class="tzh-adv-check"><input type="checkbox" id="tzhAdvEmailConsent" required><span>Ja, ich möchte meine Routine und gelegentliche Pflegehinweise per E-Mail. Widerruf in jeder Mail. <a href="https://traditional-zuerich.ch/policies/privacy-policy" target="_blank" rel="noopener noreferrer" style="color:#1B2A55;text-decoration:underline">Datenschutz</a>.</span></label>'+
      '<button class="tzh-adv-btn tzh-adv-btn-primary tzh-adv-btn-full" type="button" data-tzh-action="submit-email" style="margin-top:10px">Routine speichern</button>'+
    '</div>'+
    '<p class="tzh-adv-disclaimer">Empfehlung auf Basis deiner Angaben. Keine medizinische Diagnose. Bei anhaltenden Beschwerden bitte einen Arzt aufsuchen.</p>';

  const payload = buildPayload({ routine, bundle, level });
  track('advisor_completed', { session_id: state.sessionId, recommended_products: routine, bundle, routine_level: level });
  postWebhook(payload);
}

async function addRoutineToCart(btn){
  const handles = (btn.getAttribute('data-handles')||'').split(',').filter(Boolean);
  const bundleCode = btn.getAttribute('data-bundle');
  const originalText = btn.textContent;

  try {
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Wird hinzugefügt …';

    let skus = [];
    if(bundleCode){
      const b = PRODUCTS['BUNDLE_'+bundleCode];
      if(b && b.sku) skus = [b.sku];
    } else {
      skus = handles;
    }

    const items = await buildShopifyCartItems(skus);
    if(!items.length) throw new Error('Keine gültigen Shopify-Varianten gefunden.');

    const response = await addItemsToShopifyCart(items);
    track('advisor_add_routine', { session_id: state.sessionId, items: skus, bundle: bundleCode, destination:'shopify_cart' });
    toast(bundleCode ? 'Bundle im Warenkorb' : (items.length+' Produkte im Warenkorb'));
    renderShopifyCart(response);
    setTimeout(close, 700);
  } catch(err){
    console.error('[TZH Advisor] add to Shopify cart failed:', err);
    toast(err && err.message ? err.message : 'Warenkorb konnte nicht aktualisiert werden.');
  } finally {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.textContent = originalText;
  }
}

// --- Shopify Cart Bridge -----------------------------------------
// Shopify is the system of record. Do not use localStorage for cart.
const SKU_TO_HANDLE = {
  'beard-scrub': 'beard-scrub',
  'beard-treatment': 'beard-treatment',
  'shave-beard-oil': 'shave-beard-oil',
  'forming-cream': 'forming-cream',
  'bartbuerste-klein': 'bartbuerste-oval-klein',
  'bartbuerste-gross': 'bartbuerste-oval-gross',
  'bartbuerste-mit-griff-gross': 'bartbuerste-mit-griff-gross',
  'bartbuerste-mit-griff-klein': 'bartbuerste-mit-griff-klein',
  'bartbuerste-oval-gross': 'bartbuerste-oval-gross',
  'bartbuerste-oval-klein': 'bartbuerste-oval-klein',
  'haar-bartbuerste-mit-griff-gross': 'haar-bartbuerste-mit-griff-gross',
  'big-beard-box': 'big-beard-box',
  'bundle-starter': 'starter-routine',
  'bundle-daily': 'daily-ritual',
  'geschenk-gutschein': 'geschenk-gutschein'
};

function handleForSku(sku){
  return SKU_TO_HANDLE[sku] || sku;
}

async function getFirstAvailableVariantId(handle){
  const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
    credentials:'same-origin',
    headers:{ 'Accept':'application/json' }
  });
  if(!res.ok) throw new Error('Produkt nicht gefunden: ' + handle);
  const product = await res.json();
  const variant = (product.variants || []).find(v => v.available) || (product.variants || [])[0];
  if(!variant || !variant.id) throw new Error('Keine Variante verfügbar: ' + (product.title || handle));
  return Number(variant.id);
}

async function buildShopifyCartItems(skus){
  const seen = {};
  const clean = skus.filter(Boolean);
  clean.forEach(sku => { seen[sku] = (seen[sku] || 0) + 1; });

  const items = [];
  for(const sku of Object.keys(seen)){
    const handle = handleForSku(sku);
    const id = await getFirstAvailableVariantId(handle);
    items.push({ id: id, quantity: seen[sku] });
  }
  return items;
}

async function addItemsToShopifyCart(items){
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const body = { items: items };
  if(cart && typeof cart.getSectionsToRender === 'function'){
    body.sections = cart.getSectionsToRender().map(section => section.id);
    body.sections_url = window.location.pathname;
    if(typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }

  const url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  const res = await fetch(url, {
    method:'POST',
    credentials:'same-origin',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if(!res.ok || data.status){
    throw new Error(data.description || data.message || 'Produkt konnte nicht in den Warenkorb gelegt werden.');
  }
  return data;
}

function renderShopifyCart(response){
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if(cart && typeof cart.renderContents === 'function' && response && response.sections){
    cart.renderContents(response);
  }
  if(typeof updateCartBadge === 'function') updateCartBadge();
  document.dispatchEvent(new CustomEvent('tzh:cart-updated', { detail: response }));
}

function submitEmail(){
  const email = (document.getElementById('tzhAdvEmail')||{}).value;
  const consent = (document.getElementById('tzhAdvEmailConsent')||{}).checked;
  if(!email || !consent){ toast('Bitte E-Mail und Einwilligung'); return; }
  const { routine, bundle } = recommend(state.answers);
  const payload = buildPayload({ routine, bundle, email: email, email_consent: true });
  track('advisor_email_submit', { session_id: state.sessionId, email_hash: hash(email) });
  postWebhook(payload);
  toast('Routine per Mail unterwegs.');
  setTimeout(close, 900);
}

// --- Toast --------------------------------------------------------
function toast(msg){
  const t = document.createElement('div');
  t.textContent = msg;
  t.style.cssText = 'position:fixed;bottom:96px;left:50%;transform:translate(-50%,20px);background:#1A1614;color:#F6F1E8;padding:12px 20px;border-radius:3px;font-size:13px;font-family:Inter,system-ui,sans-serif;z-index:9999;box-shadow:0 12px 32px rgba(0,0,0,.25);opacity:0;transition:opacity .25s,transform .25s;font-weight:500;letter-spacing:.02em';
  document.body.appendChild(t);
  requestAnimationFrame(()=>{ t.style.opacity='1'; t.style.transform='translate(-50%,0)'; });
  setTimeout(()=>{ t.style.opacity='0'; t.style.transform='translate(-50%,20px)'; setTimeout(()=>t.remove(),300); }, 2400);
}

// --- Payload + Webhook (uses central TZHPayload + TZHWebhook) -----
function buildPayload(extra){
  const { routine, bundle, level } = recommend(state.answers);
  const base = {
    advisor: {
      beardLength: state.answers.length || null,
      skinFeeling: state.answers.skin_type || null,
      problem:     state.answers.problem || null,
      stylingGoal: state.answers.finish || null,
      carePreference: state.answers.care_goal || null,
      routineLevel: level || null
    },
    recommendation: {
      products: routine.map(c => ({ code:c, handle:PRODUCTS[c].handle, sku:PRODUCTS[c].sku, price:PRODUCTS[c].price, title:PRODUCTS[c].title })),
      bundle: bundle ? { code:bundle, sku:PRODUCTS['BUNDLE_'+bundle].sku, price:PRODUCTS['BUNDLE_'+bundle].price } : null,
      bundleValue: bundle ? PRODUCTS['BUNDLE_'+bundle].price : null,
      total_einzel: routine.reduce((s,c) => s + (PRODUCTS[c].price || 0), 0)
    }
  };
  return Object.assign(base, extra || {});
}
function postWebhook(extra){
  const data = buildPayload(extra || {});
  const cfg = window.TZH_CONFIG || {};
  if(window.TZHPayload && window.TZHWebhook){
    const url = cfg.webhookAdvisor || cfg.n8nBaseUrl || '';
    const payload = window.TZHPayload.build('advisor_completed', data);
    window.TZHWebhook.post(url, payload);
  } else if(cfg.debug) {
    console.log('[Advisor] Payload (no webhook configured):', data);
  }
}
function track(event, data){
  try {
    if(window.Track && typeof window.Track.push === 'function') window.Track.push(Object.assign({event}, data||{}));
    if(window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({event}, data||{}));
  } catch {}
}

// --- Utilities ----------------------------------------------------
function parseUTM(){
  const p = new URLSearchParams(window.location.search);
  const out = {};
  ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'].forEach(k => { const v=p.get(k); if(v) out[k]=v; });
  return out;
}
function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
function hash(s){ let h=0; for(let i=0;i<s.length;i++){h=((h<<5)-h)+s.charCodeAt(i);h|=0}; return 'h_'+Math.abs(h); }

// --- Global event delegation for "open-advisor" buttons -----------
// Captures clicks anywhere on the page (CTA buttons, nav, etc.)
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-action="open-advisor"]');
  if(!t) return;
  e.preventDefault();
  open();
});

// --- Mount on DOM ready -------------------------------------------
if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}

// --- Public API ---------------------------------------------------
window.Advisor = { open, close, next, prev, recommend, QUESTIONS, PRODUCTS, _state: state, _test: { recommend, buildIntro, buildBundleHint } };

// --- Self-test (only when ?advisor_test=1) ------------------------
if(/[?&]advisor_test=1/.test(location.search)){
  setTimeout(() => {
    const cases = [
      { id:'A trocken+flakes', a:{ skin_type:'Trocken', flakes:'Häufig', itch:'Manchmal', ingrown:'Manchmal', length:'Kurz (3–10 mm)', current_routine:['Nichts'], finish:'Gepflegt natürlich' }, expectIncludes:['SCRUB','TREATMENT'] },
      { id:'B fettig+lang+matt', a:{ skin_type:'Eher fettig', flakes:'Selten / Nie', itch:'Nie', ingrown:'Nie', length:'Lang (>25 mm)', current_routine:['Mehrere Produkte'], finish:'Matt' }, expectIncludes:['CREAM','BRUSH_L'] },
      { id:'C empfindlich+juckreiz+mittel', a:{ skin_type:'Empfindlich', flakes:'Manchmal', itch:'Häufig', ingrown:'Nie', length:'Mittel (10–25 mm)', current_routine:['Bartöl'], finish:'Weich' }, expectIncludes:['TREATMENT','OIL','BRUSH_L'] },
      { id:'D einsteiger', a:{ skin_type:'Normal', flakes:'Selten / Nie', itch:'Nie', ingrown:'Nie', length:'Stoppel', current_routine:['Nichts'], finish:'Gepflegt natürlich' }, expectIncludes:['TREATMENT','BRUSH_S'] },
      { id:'E ingrown+kurz', a:{ skin_type:'Normal', flakes:'Selten / Nie', itch:'Manchmal', ingrown:'Häufig', length:'Stoppel', current_routine:['Nichts'], finish:'Gepflegt natürlich' }, expectIncludes:['SCRUB'] }
    ];
    const results = cases.map(c => {
      const got = recommend(c.a).routine;
      const passed = c.expectIncludes.every(x => got.includes(x));
      return { id:c.id, got, passed, expect:c.expectIncludes };
    });
    console.table(results);
    console.log('[Advisor self-test]', results.filter(r=>r.passed).length+'/'+results.length+' passed');
  }, 50);
}
})();
